import { getTranslate } from '@/services/translate/translateService';

const i18n = require('@/i18nInstance').default;

export default {
  namespaced: true,
  state: {
    translationsLoaded: false,
  },
  mutations: {
    SET_TRANSLATIONS_LOADED(state, status) {
      state.translationsLoaded = status;
    },
  },
  getters: {
    areTranslationsLoaded: (state) => state.translationsLoaded,
  },
  actions: {
    async loadTranslations({ commit }, companyId) {
      const translations = await getTranslate({ companyId });

      i18n.global.setLocaleMessage('default', translations);
      i18n.global.locale = 'default';

      commit('SET_TRANSLATIONS_LOADED', true);
    },
  },
};
